<script lang="ts">
  import {t} from '../i18n'
  import UserCard from './UserCard.svelte'
  import type {User} from '../types'
  import SearchInput from '../shared/SearchInput.svelte'
  import Placeholder from '../shared/Placeholder.svelte'
  import LoadMore from '../shared/LoadMore.svelte'

  let users: User[] | undefined
  let search: string = ''
</script>

<div class="row">
  <div class="grid-section">
    <div class="heading with-filter inner-heading">
      <h2>{t.users.recommended.title}</h2>
      <div class="right-filter">
        <SearchInput bind:search placeholder={t.users.find}/>
      </div>
    </div>

    {#if users && users.length}
      <div class="grid three">
        {#each users as user}
          <div class="grid__item">
            <UserCard {user}/>
          </div>
        {/each}
      </div>
    {:else}
      <Placeholder placeholder={t.placeholder.no_users} loading={!users}/>
    {/if}

    <LoadMore url="/users" bind:items={users} {search}/>
  </div>
</div>
